import React, { useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';
import AddressComponent from "premier-capability-policyjob-react/components/AddressComponent/AddressComponent";
import CoveragesPageComponent from "../../../pages/Coverages/CoveragesPage";
import metadata from './ProjectDetailsComponent.metadata.json5';
import messages from './ProjectDetailsComponent.messages';
import styles from '../../BuildersRisk/BuildersRisk.module.scss';

function ProjectDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProjectDetailsComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const [isEditAddress, setIsEditAddress] = useState(false)
    const [actAddress, setActAddress] = useState(null)
    const { showConfirm } = useModal();

    modelVM.value.isValidationReq = true
    modelVM.typofInsReqFie.value = submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie
    modelVM.doyouwistorecquofoCGLFie.value = submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.doyouwistorecquofoCGLFie

    if (_.isUndefined(modelVM.accountLocFie.value)) {
            const model = { country: 'CA'}
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);
    
            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
    }

    const getAddressOptions = () => {
        const availableValues = submissionVM.value.baseData.account_Ext.accountLocations_Ext.map((actLct) => ({
            code: actLct.publicID,
            name: actLct.displayName
        }));

        return availableValues.concat({
            code: 'new',
            name: '-- Add New --'
        })
    };

    const setIsEditButton = () => {
        setActAddress(modelVM.accountLocFie.value)
        setIsEditAddress(true)
    }

    const setIsCancelButton = () => {
            const model = actAddress
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);
    
            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
            setIsEditAddress(false)
    }
    
    const setIsSaveButton = () => {
            setIsEditAddress(false)
    }

    const fillAddressDetails = (value, changedPath) => {
        handleValueChange(value, changedPath)
    
        if (value === 'new') {
            const model = { country: 'CA', publicID: value }
            const { _xCenter, _dtoName } = modelVM.accountLocFie;
            const addressDetailsVM = viewModelService.create(model, _xCenter, _dtoName);
    
            _.set(modelVM, 'accountLocFie.value', addressDetailsVM.value)
        } else {
             modelVM.accountLocFie.value = _.find(submissionVM.value.baseData.account_Ext.accountLocations_Ext, (actLct) => actLct.publicID === value);
        }
    
        handleValueChange(modelVM.accountLocFie.value, 'accountLocFie')
    };

    const onAddressChange = useCallback((value, changedPath) => {
        const fullPath = `${pathUpdated}.accountLocFie.${changedPath}`;
    
        _.set(submissionVM, `${fullPath}`, value);
        updateWizardData(submissionVM);
    }, [pathUpdated, submissionVM, updateWizardData]);

    const deleteProjectDetails = useCallback(
            () => {
                const infoListPath = 'lobData.consTraAndServLine.coverables.locRisks.value';
                const info = modelVM.value;
                const infoList = _.get(submissionVM, infoListPath);
    
                showConfirm({
                    title: messages.removeInfo,
                    message: messages.removeInfoDesc,
                    status: 'warning',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.yes,
                    cancelButtonText: messages.no
                }).then(
                    (results) => {
                        if (results === 'cancel') {
                            return _.noop();
                        }
    
                        const newinfoList = _.remove(infoList,
                            (infoFromList) => _.isEqual(infoFromList, info));
    
                        _.set(submissionVM, newinfoList, infoListPath);
                        updateWizardData(submissionVM);
    
                        return true;
                    }, _.noop
                );
            }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
        );

    const getCheckBoxValue = useCallback((values) => {
        const result = [];
        
        _.forEach(values, (value) => {
            if (value) {
                result.push(value);
                }
            });
        
            return result;
        }, []);
        


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        actAdrsPublicID: {
            availableValues: getAddressOptions(),
            onValueChange: fillAddressDetails
        },
        locRiskddressComponent: {
            labelPosition: 'left',
            value: modelVM.accountLocFie,
            viewModelService,
            readOnly: isEditAddress ? [] : ['addressLine1Field', 'addressLine2Field', 'addressLine3Field', 'addressCity', 'addressState', 'addressPostalCode'],
            hideFields: ['addressLine2Field', 'addressLine3Field', 'addressDescription', 'addressType', 'addressCountry', 'addressCounty'],
            requiredFields: ['addressLine1Field', 'postalCode'],
            onValueChange: onAddressChange
        },
        editAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && !isEditAddress
        },
        saveAddressButton: {
            visible: modelVM.actAdrsPublicID.value === 'new' || isEditAddress
        },
        cancelAddressButton: {
            visible: modelVM.actAdrsPublicID.value !== 'new' && isEditAddress
        },
        neighbouring: {
            value: getCheckBoxValue(modelVM.value.neighbouring)
        },
        ifothPledesFie : {
            visible: modelVM.extWalFie?.value?.code === "Oth"
        },
        ifothPledesFie1: {
            visible: modelVM.othFie?.value === true
        },
        ifothPledes2Fie: {
            visible: modelVM.sidFie?.value?.code === 'Oth'
        },
        ifothPle2deFie: {
            visible: modelVM.floFie?.value?.code === 'Oth'
        },
        ifothplespeFie: {
            visible: modelVM.fouFie?.value?.code === 'Oth'
        },
        ifothple2spFie: {
            visible: modelVM.rooMatFie?.value?.code === 'Oth'
        },
        ifyesdesproFie: {
            visible: modelVM.istheTorappFie?.value === true
        },
        ifYEShowmanlevFie: {
            visible: modelVM.istheUndParFie?.value === true
        },
        squfooofthefinareFie: {
            visible: !_.isUndefined(modelVM.value.typofInsReqFie) && modelVM.value.typofInsReqFie !== 'SmaResCOC'
        },
        squfoooftheunfareibasFie: {
            visible: !_.isUndefined(modelVM.value.typofInsReqFie) && modelVM.value.typofInsReqFie !== 'SmaResCOC'
        },
        onSitWatserful247Fie: {
            visible: !_.isUndefined(modelVM.value.typofInsReqFie) && modelVM.value.typofInsReqFie === 'SmaResCOC' && 
                     !_.isUndefined(modelVM.value.doyouwistorecquofoCGLFie) && modelVM.value.doyouwistorecquofoCGLFie
        },
        secPatFie: {
            visible: !_.isUndefined(modelVM.value.typofInsReqFie) && modelVM.value.typofInsReqFie === 'SmaResCOC'
        }
        
    };

    const resolvers = {
        resolveCallbackMap: {
            deleteProjectDetails,
            onValidate,
            setIsEditButton,
            setIsCancelButton,
            setIsSaveButton
        },
        resolveComponentMap: {
            coveragespagecomponent: CoveragesPageComponent,
            AddressComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

     const handleValueChange = useCallback(
            (value, changedPath) => {
                const fullPath = `${pathUpdated}.${changedPath}`;
    
                _.set(submissionVM, `${fullPath}`, value);
                
    
                updateWizardData(submissionVM);
            },
            [pathUpdated, submissionVM, updateWizardData]
        );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ProjectDetailsComponent.propTypes = wizardProps;
export default withRouter(ProjectDetailsComponent);
